<template>
  <el-dialog
    width="70%"
    class="linkDialog"
    title="设置跳转逻辑"
    :close-on-click-modal="false"
    :visible.sync="dialogShow"
    @close="dialogClose"
  >
    <el-tabs v-model="linkDialogTab" :before-leave="linkDialogTabChange">
      <el-tab-pane label="选项跳转" :disabled="linkQues.type !== 'radio'" name="0">
        <div class="linkSetBox">
          <div class="titlesList">
            <p class="titlesList-header">用户选择本题选项：</p>
            <ul>
              <li
                :class="{'titlesList-item': true, 'active': i === activeOpt, 'hasSub': optLinkData[i] && i !== activeOpt}"
                v-for="(item, i) in linkQues.options"
                @click="handleSelectOpt(i)"
                :key="item.id"
              >
                <p class="titlesList-text">{{letterMap[i] + '. ' + removeLables(item.text)}}</p>
                <span class="titlesList-sub" v-if="optLinkData[i] && i !== activeOpt">1</span>
              </li>
            </ul>
          </div>
          <div class="settingPart">
            <div class="settingHeader">
              跳转至：
              <el-select v-model="currentLinkPage1" @change="handleSelectPage">
                <el-option label="默认" :value="0"></el-option>
                <el-option label="结束页" :value="survey.pages.length"></el-option>
                <el-option label="无效问卷" :value="-1"></el-option>
              </el-select>
            </div>
            <div class="settingBody">
              <p
                v-if="currentLinkPage1 > -1 && currentLinkPage1 < survey.pages.length"
                class="settingBody-tips"
              >题目跳转</p>
              <div
                class="settingBody-list"
                v-if="survey.pages.length > 0 && currentLinkPage1 < survey.pages.length && currentLinkPage1 > -1"
              >
                <ul v-for="(page, i) in survey.pages" :key="i">
                  <p>第{{ i + 1 }}页</p>
                  <li
                    :class="{'settingBody-item': true, 'active': optActiveQues == ques.id, 'disabled': ques.index <= linkQues.index}"
                    v-for="(ques, idx) in page.questions"
                    v-if="ques.type !== 'description'"
                    @click="handleSelectQues(ques)"
                    :key="idx"
                  >{{(ques.index + 1) + '. ' + removeLables(ques.title)}}</li>
                </ul>
              </div>
              <p class="settingBody-tips" v-if="currentLinkPage1 == -1">选择该选项归入无效填答</p>
              <p class="settingBody-tips" v-if="currentLinkPage1 == survey.pages.length">选择该选项跳至结束页</p>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="分页跳转" name="1">
        <div class="settingPart noReason">
          <div class="settingHeader">
            答完本题后跳转至：
            <el-select v-model="currentLinkPage2" @change="handleSelectPage2">
              <el-option label="默认" :value="-1"></el-option>
              <el-option
                v-if="i > (activePage - 1)"
                :label="'第' + (i + 1) + '页'"
                :value="i"
                v-for="(page, i) in survey.pages"
                :key="page.id"
              ></el-option>
              <el-option label="结束页" :value="survey.pages.length"></el-option>
            </el-select>
          </div>
          <div class="settingBody">
            <ul
              class="settingBody-list"
              v-if="survey.pages.length > 0 && currentLinkPage2 < survey.pages.length && currentLinkPage2 > -1"
            >
              <li
                :class="{'settingBody-item': true, 'active': noReasonActiveQues == ques.index, 'disabled': true}"
                v-for="(ques, idx) in survey.pages[currentLinkPage2].questions"
                v-if="ques.type !== 'description'"
                :key="idx"
              >{{(ques.index + 1) + '. ' + removeLables(ques.title)}}</li>
            </ul>
            <p class="settingBody-tips" v-if="currentLinkPage2 == survey.pages.length">完成该题跳至结束页</p>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="显示逻辑" name="2">
        <div class="linkSetBox">
          <div class="titlesList">
            <p class="titlesList-header">用户选择本题选项：</p>
            <ul>
              <li
                :class="{'titlesList-item': true, 'active': i == visibleActiveOpt, 'hasSub': visibleOptLinkData[i] && visibleOptLinkData[i].length > 0 && i !== visibleActiveOpt}"
                v-for="(item, i) in linkQues.options"
                @click="handleSelectVisibleOpt(i)"
                :key="item.id"
              >
                <p class="titlesList-text">{{letterMap[i] + '. ' + removeLables(item.text)}}</p>
                <span
                  class="titlesList-sub"
                  v-if="visibleOptLinkData[i] && visibleOptLinkData[i].length > 0 && i !== visibleActiveOpt"
                >{{ visibleOptLinkData[i].length }}</span>
              </li>
            </ul>
          </div>
          <div class="settingPart">
            <div class="settingBody">
              <p class="settingBody-tips">
                题目显示
                <span class="info">
                  <i class="el-icon-info"></i>可多选，选中该选项后才显示该题
                </span>
              </p>
              <div class="settingBody-list" v-if="survey.pages.length > 0">
                <ul v-for="(page, i) in survey.pages" :key="i">
                  <p>第{{ i + 1 }}页</p>
                  <li
                    :class="{'settingBody-item': true, 'active': visibleOptActiveQues.indexOf(ques.id) > -1, 'disabled': ques.index <= linkQues.index}"
                    v-for="(ques, idx) in page.questions"
                    v-if="ques.type !== 'description'"
                    @click="handleSelectVisibleQues(ques)"
                    :key="idx"
                  >{{(ques.index + 1) + '. ' + removeLables(ques.title)}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="多条件显示" name="3">
        <div class="titlesList">
          <p class="titlesList-header">用户选择本题选项：</p>
          <ul>
            <li
              :class="{'titlesList-item': true, 'active': mulActiveOpt == i}"
              v-for="(item, i) in linkQues.options"
              @click="handleSelectMultiOpt(item, i)"
              :key="item.id"
            >{{letterMap[i] + '. ' + removeLables(item.text)}}</li>
          </ul>
        </div>
        <div class="titlesList">
          <p class="titlesList-header">二级条件：</p>
          <ul>
            <li
              v-for="(item, i) in allQues"
              :key="i"
              :class="{'multiList-item': true}"
              v-if="item.index > linkQues.index"
            >
              <p
                :class="{'active': mulActiveQuesId == item.id}"
                @click="handleMulSec(item)"
              >{{ item.index + 1 + '. ' + removeLables(item.title) }}</p>
              <ul :class="{'hidden': mulActiveQuesId != item.id}">
                <li
                  :class="{'multiOpt-item': true, 'active': mulActiveSecOpt.indexOf(optIdx) > -1}"
                  v-for="(opt, optIdx) in item.options"
                  :key="optIdx"
                  @click="handleSelectMultiSecOpt(optIdx)"
                >{{letterMap[optIdx] + '. ' + removeLables(opt.text)}}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="settingPart multiple">
          <div v-if="mulActiveQuesId">
            <div class="settingHeader">
              同时满足时跳转至：
              <el-select v-model="currentLinkPage3" @change="handleSelectPage3">
                <!-- <el-option :label="'第' + (i + 1) + '页'" :value="i" v-for="(page, i) in survey.pages" :key="page.id"></el-option> -->
                <el-option label="默认" :value="0"></el-option>
                <el-option label="结束页" :value="survey.pages.length"></el-option>
                <el-option label="无效问卷" :value="-1"></el-option>
              </el-select>
            </div>
            <div class="settingBody">
              <p
                v-if="currentLinkPage3 > -1 && currentLinkPage3 < survey.pages.length"
                class="settingBody-tips"
              >
                题目跳转
                <span class="info">
                  <i class="el-icon-info"></i>可多选
                </span>
              </p>
              <div
                class="settingBody-list"
                v-if="survey.pages.length > 0 && currentLinkPage3 < survey.pages.length && currentLinkPage3 > -1"
              >
                <ul v-for="(page, i) in survey.pages" :key="i">
                  <p>第{{i + 1}}页</p>
                  <li
                    :class="{'settingBody-item': true, 'active': mulOptActiveQues.indexOf(ques.id) > -1, 'disabled': ques.index <= mulActiveQues}"
                    v-for="(ques, idx) in page.questions"
                    :key="idx"
                    v-if="ques.type !== 'description'"
                    @click="handleSelectMulTarget(ques)"
                  >{{(ques.index + 1) + '. ' + removeLables(ques.title)}}</li>
                </ul>
              </div>
              <p class="settingBody-tips" v-if="currentLinkPage3 == -1">选择该选项归入无效填答</p>
              <p class="settingBody-tips" v-if="currentLinkPage3 == survey.pages.length">选择该选项跳至结束页</p>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const tabsMap = ["选项跳转", "分页跳转", "显示逻辑", "多条件显示"];
import { MSG } from "../utils/utils";
export default {
  name: "linkDialogNew",
  data() {
    return {
      linkDialogTab: "0",
      currentLinkPage1: 0,
      currentLinkPage2: -1,
      currentLinkPage3: 0,
      dialogShow: false,
      activeOpt: 0, //选项跳转中的当前选项
      optActiveQues: "", //选项跳转中要跳转的题目
      mulOptActiveQues: [], //多条件中要跳转的题目
      optLinkData: [], //导出的选项跳转数组
      noReasonActiveQues: "-1", //无条件跳转中要跳转的题目
      noReasonActiveQuesId: "",
      noReasonActivePageId: "-1", //无条件跳转的页数
      mulActiveOpt: 0, //多条件中的当前选项
      mulActiveQues: "", //多条件中二级条件选中的题目
      mulActiveQuesId: "", //多条件中二级条件选中的题目Id
      mulActiveSecOpt: [], //多条件中二级条件选中的选项
      visibleActiveOpt: 0, //显示逻辑中的当前选项
      visibleOptActiveQues: [], //显示逻辑中要显示的题目
      visibleOptLinkData: [], //显示逻辑中导出的选项显示数组
      tabClickFlag: false
    };
  },
  watch: {
    isShow: function() {
      const _tab = this.getDialogTab();
      if (_tab !== this.linkDialogTab) {
        this.tabClickFlag = true;
        this.linkDialogTab = _tab;
      }
      this.dialogShow = this.isShow;
      this.currentLinkPage1 = 0;
      if (+this.linkQues.goto === -1) {
        this.currentLinkPage2 = -1;
      } else if (+this.linkQues.goto === -2) {
        this.currentLinkPage2 = this.survey.pages.length;
      } else {
        this.currentLinkPage2 = this.calcToPage(this.linkQues.goto) - 1;
      }
      this.currentLinkPage3 = 0;
      this.mulActiveOpt = 0;
      this.mulActiveQuesId = "";
      this.mulActiveSecOpt = [];
      this.mulOptActiveQues = [];
      this.activeOpt = 0;
      this.visibleActiveOpt = 0;
    },
    linkQues: function() {
      this.noReasonActiveQues = this.linkQues.goto;
      this.noReasonActiveQuesId = this.linkQues.gotoQId;
      if (this.linkQues.type === "radio" || this.linkQues.type === "checkbox") {
        this.optLinkData = this.linkQues.options.map(item => {
          return item.gotoId;
        });
        this.visibleOptLinkData = this.linkQues.options.map(item => {
          if (!item.visibleId) {
            return [];
          }
          return item.visibleId;
        });
        this.optActiveQues = this.optLinkData[this.activeOpt];
        this.visibleOptActiveQues = this.visibleOptLinkData[
          this.visibleActiveOpt
        ];

        this.linkQues.options.forEach((val, i) => {
          if (val.mulKeyId) {
            this.mulActiveOpt = i;
            this.mulActiveQues = this.calcMulKey(val.mulKeyId);
            this.mulActiveQuesId = val.mulKeyId.split("_")[0];
            this.mulActiveSecOpt = val.mulKeyId
              .split("_")[1]
              .split(",")
              .map(val => {
                return +val;
              });
            this.mulOptActiveQues = val.mulToQuesId;
          }
        });
      }
    }
  },
  props: ["linkQues", "survey", "letterMap", "isShow", "activePage"],
  computed: {
    allQues() {
      let _arr = [];
      this.survey.pages.forEach(val => {
        val.questions.forEach(ques => {
          if (ques.type === "radio" || ques.type === "checkbox")
            _arr.push(ques);
        });
      });
      return _arr;
    }
  },
  methods: {
    calcMulKey(mulKey) {
      let count = 0;
      let id = mulKey.split("_")[0];
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          count++;
          if (id == _page.questions[j].id) {
            return count;
          }
        }
      }
    },
    handleSelectPage() {
      this.optActiveQues = this.optLinkData[this.activeOpt] || "";
      // -1 无效， -2 结束页
      if (this.currentLinkPage1 === -1) {
        this.optLinkData.splice(this.activeOpt, 1, "-1");
      } else if (this.currentLinkPage1 === this.survey.pages.length) {
        this.optLinkData.splice(this.activeOpt, 1, "-2");
      } else {
        if (+this.optLinkData[this.activeOpt] < 0) {
          this.optLinkData.splice(this.activeOpt, 1, "");
          this.optActiveQues = "";
        }
      }
    },
    handleSelectPage2() {
      if (this.currentLinkPage2 === -1) {
        this.noReasonActiveQues = "-1";
      } else if (this.currentLinkPage2 === this.survey.pages.length) {
        this.noReasonActiveQues = "-2";
      } else {
        this.noReasonActiveQues =
          this.survey.pages[this.currentLinkPage2].questions[0].index + "";
        this.noReasonActiveQuesId = this.survey.pages[
          this.currentLinkPage2
        ].questions[0].id;
        this.noReasonActivePageId = this.survey.pages[this.currentLinkPage2].id;
      }
    },
    handleSelectPage3() {
      if (this.currentLinkPage3 === -1) {
        this.mulOptActiveQues = [-1];
      } else if (this.currentLinkPage3 === this.survey.pages.length) {
        this.mulOptActiveQues = [-2];
      } else {
        this.mulOptActiveQues = [];
      }
    },
    linkDialogTabChange(activeName, oldActiveName) {
      if (this.tabClickFlag) {
        this.tabClickFlag = false;
        return true;
      }
      this.$confirm(
        "切换成" +
          tabsMap[activeName] +
          "后，原有的" +
          tabsMap[oldActiveName] +
          "将失效哦，是否切换?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.tabClickFlag = true;
          this.linkDialogTab = activeName + "";
        })
        .catch(() => {
          this.tabClickFlag = false;
        });
      return false;
    },
    dialogClose() {
      this.$emit("close");
    },
    removeLables(html) {
      return html.replace(/<\/?.+?>/g, "");
    },
    handleSelectOpt(i) {
      this.activeOpt = i;
      this.optActiveQues = this.optLinkData[i] || "";
      if (+this.optActiveQues === -1) {
        this.currentLinkPage1 = -1;
      } else if (+this.optActiveQues === -2) {
        this.currentLinkPage1 = this.survey.pages.length;
      } else {
        this.currentLinkPage1 = 0;
      }
    },
    handleSelectVisibleOpt(i) {
      this.visibleActiveOpt = i;
      this.visibleOptActiveQues = this.visibleOptLinkData[i] || [];
    },
    handleSelectQues({ index, id }) {
      if (index <= this.linkQues.index) return;
      if (this.optActiveQues === id) {
        this.optActiveQues = "";
      } else {
        this.optActiveQues = id;
      }
      this.optLinkData.splice(this.activeOpt, 1, this.optActiveQues);
    },
    handleSelectVisibleQues({ index, id }) {
      if (index <= this.linkQues.index) return;
      if (this.visibleOptActiveQues.indexOf(id) > -1) {
        this.visibleOptActiveQues.splice(
          this.visibleOptActiveQues.indexOf(id),
          1
        );
      } else {
        this.visibleOptActiveQues.push(id);
      }
      this.visibleOptLinkData.splice(
        this.visibleActiveOpt,
        1,
        this.visibleOptActiveQues
      );
    },
    handleSelectMulTarget({ index, id }) {
      if (index <= this.mulActiveQues) return;
      if (this.mulOptActiveQues.indexOf(id) > -1) {
        this.mulOptActiveQues.splice(this.mulOptActiveQues.indexOf(id), 1);
      } else {
        this.mulOptActiveQues.push(id);
      }
    },
    handleSelectMultiOpt(item, i) {
      this.mulActiveOpt = i;
      if (item.mulKey) {
        this.mulActiveQuesId = item.mulKey.split("_")[0];
        this.mulActiveSecOpt = item.mulKey
          .split("_")[1]
          .split(",")
          .map(val => {
            return +val;
          });
        this.mulOptActiveQues = item.mulToQuesId;
      } else {
        this.mulActiveQuesId = "";
        this.mulActiveSecOpt = [];
        this.mulOptActiveQues = [];
      }
    },
    handleMulSec(ques) {
      this.mulActiveQuesId = ques.id;
      this.mulActiveQues = ques.index;
      this.mulActiveSecOpt = [];
    },
    handleSelectMultiSecOpt(idx) {
      if (this.mulActiveSecOpt.indexOf(idx) > -1) {
        this.mulActiveSecOpt.splice(this.mulActiveSecOpt.indexOf(idx), 1);
      } else {
        this.mulActiveSecOpt.push(idx);
      }
    },
    handleConfirm() {
       if (this.linkDialogTab === "0") {
        this.$emit("linkConfirm", {
          noReasonLink: "-1",
          optLink: this.optLinkData,
          mulToQues: [],
          mulToQuesId: [],
          mulKey: "",
          mulKeyId: "",
          visible: [],
          visibleId: []
        });
      } else if (this.linkDialogTab === "1") {
        this.$emit("linkConfirm", {
          noReasonLink: this.noReasonActiveQues,
          gotoQId: this.noReasonActivePageId,
          optLink: this.optLinkData.fill(""),
          mulToQues: [],
          mulToQuesId: [],
          mulKey: "",
          mulKeyId: "",
          visible: [],
          visibleId: []
        });
      } else if (this.linkDialogTab === "2") {
        this.$emit("linkConfirm", {
          noReasonLink: "-1",
          optLink: this.optLinkData.fill(""),
          mulToQues: [],
          mulToQuesId: [],
          mulKey: "",
          mulKeyId: "",
          optIdx: this.visibleActiveOpt,
          visible: [],
          visibleId: this.visibleOptActiveQues
        });
      } else if (this.linkDialogTab === "3") {
        // 多条件跳转和其他跳转互斥
        if (
          this.mulActiveSecOpt.length === 0 ||
          this.mulOptActiveQues.length === 0 ||
          this.mulActiveQuesId === ""
        ) {
          MSG.error("配置未完成");
          return;
        }
        this.mulActiveSecOpt = this.mulActiveSecOpt.sort((a, b) => {
          return a - b;
        });
        this.$emit("linkConfirm", {
          noReasonLink: "-1",
          optLink: this.optLinkData.fill(""),
          mulToQues: [],
          mulToQuesId: this.mulOptActiveQues,
          mulKey: "",
          mulKeyId: this.mulActiveQuesId + "_" + this.mulActiveSecOpt.join(","),
          optIdx: this.mulActiveOpt,
          visible: [],
          visibleId: []
        });
      } 
      this.dialogShow = false;
    },
    calcToPage(goto) {
      let _sum = 0;
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          if (_page.questions[j].type !== "description") {
            if (_sum === +goto) return i + 1;
            _sum++;
          }
        }
      }
    },
    getDialogTab() {
      if (this.linkQues.goto !== "-1") {
        return "1";
      } else {
        for (let i = 0; i < this.linkQues.options.length; i++) {
          if (this.linkQues.options[i].goto) {
            return "0";
          } else if (
            this.linkQues.options[i].visibleId &&
            this.linkQues.options[i].visibleId.length > 0
          ) {
            return "2";
          } else if (this.linkQues.options[i].mulKeyId) {
            return "3";
          }
        }
      }
      if (this.linkQues.type === "checkbox") {
        return "1";
      } else {
        return "0";
      }
    }
  }
};
</script>

<style lang="scss">
.titlesList {
  float: left;
  width: 180px;
  background-color: #f0f0f0;
  border: 1px solid #dcdfe6;
  height: 340px;
  padding: 10px 0;
  overflow-y: auto;
  & + .titlesList {
    border-left: 0;
  }
  .titlesList-header {
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    padding-left: 10px;
  }
  .titlesList-item {
    width: 100%;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      background-color: rgba(232, 103, 82, 0.3);
    }
    &.active {
      background-color: rgba(232, 103, 82, 0.9);
      color: #fff;
    }
    &.hasSub {
      background-color: rgba(232, 103, 82, 0.2);
    }
  }
  .multiList-item {
    p {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        background-color: rgba(232, 103, 82, 0.2);
      }
      &.active {
        background-color: rgba(232, 103, 82, 0.6);
        color: #fff;
      }
    }
    .multiOpt-item {
      padding: 0 30px;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        background-color: rgba(232, 103, 82, 0.2);
      }
      &.active {
        background-color: rgba(232, 103, 82, 0.4);
      }
    }
    ul {
      &.hidden {
        display: none;
      }
    }
  }
  .titlesList-text {
    float: left;
    width: calc(100% - 15px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .titlesList-sub {
    float: right;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    font-size: 12px;
    line-height: 14px;
    margin-top: 8px;
    background-color: #fff;
    color: #ff552e;
    text-align: center;
  }
}
.settingPart {
  float: left;
  width: calc(100% - 180px);
  height: 340px;
  border: 1px solid #dcdfe6;
  border-left: 0;
  &.multiple {
    width: calc(100% - 360px);
  }
  .settingHeader {
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #dcdfe6;
    padding-left: 15px;
    .el-select {
      width: 120px;
      .el-input__inner {
        height: 30px;
        line-height: 30px;
      }
    }
  }
  .settingBody {
    height: 295px;
    .settingBody-tips {
      padding: 8px 15px;
      .info {
        font-size: 12px;
        color: #999;
        margin-left: 10px;
      }
    }
    .settingBody-list {
      height: calc(100% - 40px);
      overflow-y: auto;
      padding: 0 15px 20px;
    }
    .settingBody-item {
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      padding: 0 15px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        background-color: rgba(232, 103, 82, 0.2);
      }
      &.active {
        background-color: rgba(232, 103, 82, 0.4);
      }
      &.disabled {
        color: #999;
        cursor: not-allowed;
      }
    }
  }
}
.noReason {
  border-left: 1px solid #dcdfe6;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/linkDialog-new.vue